<script setup>
import { ref } from 'vue';
import PageLayout from 'dashboard/components-next/layout/PageLayout.vue';
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summarReportsRef = ref(null);

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};
</script>

<template>
  <PageLayout>
    <template #header>
      <PageHeader
        icon="i-lucide-inbox"
        accent="cyan"
        :title="$t('INBOX_REPORTS.HEADER')"
        :subtitle="$t('INBOX_REPORTS.DESCRIPTION')"
      >
        <template #actions>
          <V4Button
            :label="$t('INBOX_REPORTS.DOWNLOAD_INBOX_REPORTS')"
            icon="i-ph-download-simple"
            size="sm"
            @click="onDownloadClick"
          />
        </template>
      </PageHeader>
    </template>

    <SummaryReports
      ref="summarReportsRef"
      action-key="summaryReports/fetchInboxSummaryReports"
      getter-key="inboxes/getInboxes"
      fetch-items-key="inboxes/get"
      summary-key="summaryReports/getInboxSummaryReports"
      type="inbox"
    />
  </PageLayout>
</template>
